// extracted by mini-css-extract-plugin
export default {"formItem":"input_formItem__BUqG0"};